/**
 * bootAppMatchLoop — Wire live animate/projection loop (keeps app.js under max-lines).
 */
import { bootMatchLoop } from './bootMatchLoop.js';
import { bootFighterBuffOverlay } from '../bootFighterBuffOverlay.js';

export function bootAppMatchLoop({
  THREE,
  camera,
  renderer,
  scene,
  inputController,
  matchRuntime,
  matchOutcomeWire,
  mapObjectives,
  entityInspect,
  minimap,
  activeMinions,
  activeProjectiles,
  activeJungleCamps,
  getBlueSpawner,
  getRedSpawner,
  mapBounds,
  wallBoxes,
  bushZones,
  impassableZones,
  recentDamageEvents,
  addMinionsToScene,
  MeshFactory,
  championEntity,
  dummyEntity,
  tickSummonerSpells,
  abilityCasterVfx,
  tickMpPresence,
  mapSceneState,
  championGroup,
  dom,
  hudUI,
  getRedTurretEntity,
  garenEntity,
  garenGroup,
  dummyPlateDiv,
  dummyHpBar,
  dummyGroup,
  getTurretRenderObjects,
  tickPingHud
}) {
  const fighterBuff = bootFighterBuffOverlay({
    THREE,
    parent: championGroup,
    getChampion: () => championEntity
  });
  return bootMatchLoop({
    THREE,
    camera,
    renderer,
    scene,
    inputController,
    matchRuntime,
    matchOutcomeWire,
    mapObjectives,
    entityInspect,
    minimap,
    activeMinions,
    activeProjectiles,
    activeJungleCamps,
    getBlueSpawner,
    getRedSpawner,
    mapBounds,
    wallBoxes,
    bushZones,
    impassableZones,
    recentDamageEvents,
    addMinionsToScene,
    MeshFactory,
    championEntity,
    dummyEntity,
    garenEntity,
    tickSummonerSpells,
    abilityCasterVfx,
    tickMpPresence,
    tickPingHud,
    tickFighterBuff: fighterBuff.tick,
    mapSceneState,
    projectionDeps: () => ({
      championEntity,
      championGroup,
      playerPlate: dom.playerPlate,
      respawnAsheBtn: dom.respawnAsheBtn,
      camera,
      playerHpBar: dom.playerHpBar,
      hudHpBarInner: dom.hudHpBarInner,
      playerMpBar: dom.playerMpBar,
      hudMpBarInner: dom.hudMpBarInner,
      mpText: dom.mpText,
      hudUI,
      redTurretEntity: getRedTurretEntity(),
      garenEntity,
      bushZones,
      garenPlate: dom.garenPlate,
      garenHpBar: dom.garenHpBar,
      garenGroup,
      garenStunBadge: dom.garenStunBadge,
      dummyEntity,
      dummyPlateDiv,
      dummyHpBar,
      dummyGroup,
      turretRenderObjects: getTurretRenderObjects(),
      activeMinions,
      minionsUiContainer: dom.minionsUiContainer,
      scene,
      mapId: matchRuntime.mapId,
      activeWards: matchRuntime.activeWards || [],
      wallBoxes
    })
  });
}
